/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Quick_Prep_RecapInputs */



/**
* | output |
* | --- |
* | "Summary of the previous conversation" |
*
* @param {Chat_Quick_Prep_RecapInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_quick_prep_recap = /** @type {((inputs?: Chat_Quick_Prep_RecapInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Quick_Prep_RecapInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Samenvatting vorig gesprek")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Résumé de la conversation précédente")
	return /** @type {LocalizedString} */ ("Summary of the previous conversation")
});